import { render } from "./createPublicComponent.vue?vue&type=template&id=402f5dc9&scoped=true"
import script from "./createPublicComponent.vue?vue&type=script&lang=js"
export * from "./createPublicComponent.vue?vue&type=script&lang=js"

import "./createPublicComponent.vue?vue&type=style&index=0&id=402f5dc9&lang=less"
import "./createPublicComponent.vue?vue&type=style&index=1&id=402f5dc9&lang=css"
import "./createPublicComponent.vue?vue&type=style&index=2&id=402f5dc9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402f5dc9"]])

export default __exports__